import clsx from "clsx";

import { DateTimeTz, Icon } from "@web-app/components";
import { RouteTimeline } from "@web-app/types";
import { timeZoneMap } from "@web-app/utils/helpers";

type DispatchDispatchActivityPropTypes = {
  item: RouteTimeline;
  showTimelineBar: boolean;
  timezone: keyof typeof timeZoneMap | undefined;
};

export default function RouteDispatchActivity({
  item,
  showTimelineBar,
  timezone,
}: DispatchDispatchActivityPropTypes) {
  return (
    <li key={item.id} className="relative flex gap-x-2 md:gap-x-4">
      <div
        className={clsx(
          showTimelineBar ? "-bottom-6" : "h-6",
          "absolute left-0 top-0 flex w-6 justify-center",
        )}
      >
        <div className="w-px bg-gray-200" />
      </div>
      <div className="relative flex h-7 w-6 flex-none items-center justify-center bg-white">
        <Icon name="fasCarSide" className="h-3 md:h-4 text-black" />
      </div>
      <p className="flex-auto flex flex-col items-start py-0.5 text-[10px] md:text-xs leading-0 md:leading-5 text-gray-500">
        <span className="inline-block font-medium text-gray-900">
          Dispatched route
        </span>
        <span className="text-[10px] md:text-xs text-gray-600 break-words">
          {item.updatedValue}
        </span>
        <span className="relative">
          <DateTimeTz
            start={new Date(item?.createdAt)}
            timezone={timezone}
            createdBy={
              item.dispatchLogic
                ? `Dispatch logic: ${item.dispatchLogic.name}`
                : `${item.createdBy?.name || "System"}`
            }
            presentation="timeline"
          />
        </span>
      </p>
    </li>
  );
}
